module.exports = __webpack_public_path__ + "dfdff59d51d8e3882eb08985abe91b67.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/action-icons/challenge-small.png
// module id = 1546
// module chunks = 0